"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M1.39 2.81C1 3.2 1 3.83 1.39 4.22l.61.61V16c0 1.1.9 2 2 2h11.17l4.61 4.61c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L2.81 2.81c-.39-.39-1.03-.39-1.42 0m4.99 6.4L8.17 11H7c-.55 0-1-.45-1-1 0-.32.15-.6.38-.79M7 14c-.55 0-1-.45-1-1s.45-1 1-1h2.17l2 2zm7.83-2-1-1H17c.55 0 1-.45 1-1s-.45-1-1-1h-5.17l-1-1H17c.55 0 1-.45 1-1s-.45-1-1-1H8.83l-4-4H20c1.1 0 2 .9 2 2v15.17L16.83 14H17c.55 0 1-.45 1-1s-.45-1-1-1z"
}), 'CommentsDisabledRounded');